import * as yup from "yup"

export const pictureValidation = yup.object().shape({
    asset_picture_code : yup.string().label("Picture Code").required(),
    asset_picture_name: yup.string().label("Picture Name").required(),
    description: yup.string().label("Description").required(),
    asset_foto: yup.mixed().required(),
    asset_picture_id: yup.number().label("").optional(),
});

export type PictureType = yup.InferType<typeof pictureValidation>